import React from 'react';
import { Helmet } from 'react-helmet';

function KlaraMeasssage(props) {
//   const { user } = props;
  return (
    <div>
      <Helmet>
        <script type="text/javascript">
          window.klaraWidget = window.klaraWidget || [];
          window.klaraWidget.push(["setWidgetId",
          "2b399f1c-39b8-401e-bf68-61ebb425dd6a"]);
        </script>
        <script
          type="text/javascript"
          src="https://s3.amazonaws.com/widget-frontend.klara.com/bundle.js"
        >
          {' '}
        </script>
      </Helmet>
    </div>
  );
}

export default KlaraMeasssage;
